import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=580afbce&scoped=true"
import script from "./QuestionDetail.vue?vue&type=script&lang=js"
export * from "./QuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&id=580afbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580afbce",
  null
  
)

export default component.exports